import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Formik, yupToFormErrors } from 'formik';
import { Space, Button, Form, Alert } from "antd";
import { DownloadOutlined } from '@ant-design/icons';
import * as Yup from 'yup';
import { filter } from 'lodash';
import * as constants from '../constants';

import uistate from '../../uistate';
import globalappstate from '../../globalappstate';
import common from '../../../common';
import core from '../../core';


const { TextArea, SelectInput, CheckboxInput, DatePickerInput, DisplayFormikState } = core;
const ButtonGroup = Button.Group;
const FormItem = Form.Item;

const FormSchema = Yup.object().shape({
    //beschrijving: Yup.string().required('*'),
});

const formItemLayout = {
    labelCol: { span: 4 },
    wrapperCol: { span: 18 },
}

const tailFormItemLayout = {
    wrapperCol: {
        xs: {
            span: 24,
            offset: 0,
        },
        sm: {
            span: 14,
            offset: 4,
        },
    },
};

class EditDossierFileForm extends Component {

    onSave = (values, { setSubmitting, setErrors }) => {
        //console.log('yep3');
        if (this.props.onSave) {
            //op onderstaande manier omdat we in een dialog de boel gewoon willen sluiten en geen feedback geven (en dus geen promise returnen van parent)
            Promise.resolve(this.props.onSave(values)).then(() => {
                setSubmitting(false);
            })
                .catch(err => {
                    setSubmitting(false);
                    setErrors()
                });
        } else {
            setSubmitting(false)
        }
    }
    label = (key) => {
        return common.getLabel(this.props.labels, constants.NAME, 'EditDossierFileForm', key);
    }

    CreateForm = (props) => {
        const userHasReadonlyRights = false; //!this.props.currentUsersCompanyRights.includes(common.rights.BedrijfMuteren);
        const showFileType = this.props.dossiertype == common.DOSSIER_TYPES.ProcessingActivity || 1 == 2; //uitbreiden adhv dossiertypes...
        const dossiertype = this.props.dossiertype;
        const fileTypes = filter(this.props.picklists.fileTypes, function (t) {
            return t.usedIn.includes(',' + dossiertype + ',');
        });

        return (
            <Form layout='horizontal' style={{ margin: 10 }}>
                <FormItem label={this.label("File")}{...formItemLayout}>
                    <Button onClick={() => { this.props.downloadLinkedFile(props.values.idDossierLinkedFile) }}>
                        <DownloadOutlined /> {props.values.filename}
                    </Button>
                </FormItem>

                {showFileType &&
                    <>
                        <SelectInput {...props} name="idFileType" nameField="name" idField="id" items={fileTypes} label={this.label("FileType")} formItemLayout={formItemLayout} />
                        <DatePickerInput {...props} name="date" showTime={false} label={this.label("Date")} placeholder={this.label("DatePlaceholder")} formItemLayout={formItemLayout} />
                    </>
                }
                <TextArea {...props} name="description" readOnly={userHasReadonlyRights} label={this.label("Description")} formItemLayout={formItemLayout} rows={4} />

                <FormItem {...tailFormItemLayout}>
                    <ButtonGroup className='entity-form-btns'>
                        <Button disabled={props.isSubmitting || userHasReadonlyRights} onClick={this.props.onCancel}>{this.label("Cancel")} </Button>
                        <Button type="primary" onClick={() => props.handleSubmit()} disabled={props.isSubmitting || userHasReadonlyRights} > {this.label("Save")} </Button>
                    </ButtonGroup>
                </FormItem>

                {props.isSubmitting &&
                    <Alert
                        message={this.label("Saving")}
                        style={{ marginTop: 20 }}
                    />
                }
                {/* <DisplayFormikState {...props} /> */}
            </Form>
        )
    }

    render() {
        return (
            <Formik enableReinitialize={true}
                initialValues={this.props.datacontext}
                validationSchema={FormSchema}
                onSubmit={this.onSave}
                render={this.CreateForm}
            />
        );
    }
}
function mapStateToProps(state) {
    return {
        picklists: globalappstate.selectors.allPicklists(state),
        labels: uistate.selectors.uiLabels(state),
    };
}


export default connect(mapStateToProps, {})(EditDossierFileForm);


